module.exports = __webpack_public_path__ + "static/Step 1-0f61dec3f015f1ef3b06d6478879344f.png";